'use client';

import type { ComponentType } from 'react';

import { BrandSpotlight } from './BrandSpotlight';
import HeroCardTile4up from './HeroCardTile4Up';
import { PromoCarousel } from './PromoCarousel';
import type { StorytellingCardUpProps, StorytellingVariant } from './types';

const components = {
    'Card Promo - Carousel': PromoCarousel,
    'Brand Spotlight': BrandSpotlight,
    'Hero Card 4 up': HeroCardTile4up,
} as Record<StorytellingVariant, ComponentType<StorytellingCardUpProps>>;

export function StorytellingCardUp(props: StorytellingCardUpProps) {
    const Component = components[props.variant] ?? 'div';

    return <Component {...props} />;
}
